<!--  用章申请页面  -->
<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        用章申请
        <small>用章申请</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 用章申请
          </a>
        </li>
        <li class="active">用章申请</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="col-sm-12">
        <div id="atptoolbar"></div>

        <!--  申请表单  -->
        <div class="apply-form">
          <!-- modal-body-->
          <div class="modal-body">

            <div class="panel-body">

              <!-- 开始时间 -->
              <div class="form-group">
                <label class="control-label col-xs-12 col-sm-6 no-padding-right"
                       for="useTime">用章日期:
                  <input
                    id="useTime"
                    name="useTime"
                    type="text"
                    class="form-control field"
                    @click="datePicker('useTime')"
                  />
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  印章类别
                  <select class="form-control" v-model="form.category">
                    <option value="">请选择印章类别</option>
                    <option value="公章">公章</option>
                    <option value="合同章">合同章</option>
                    <option value="发票章">发票章</option>
                    <option value="财务章">财务章</option>
                    <option value="人名章">人名章</option>
                  </select>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  文件名称
                  <input type="text" class="form-control" v-model="form.fileName"
                         placeholder="请输入文件名称"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  用途说明
                  <input type="text" class="form-control" v-model="form.forUse"
                         placeholder=""/>
                </label>
              </div>


              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  份数
                  <input type="number" class="form-control" v-model="form.quantity"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  备注
                  <input type="text" class="form-control" v-model="form.remark"
                         placeholder=""/>
                </label>
              </div>


            </div>

          </div>
          <!-- modal-footer -->
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
            <button type="button" class="btn btn-primary" @click="submit">确定</button>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>

  import {datepicker} from 'eonasdan-bootstrap-datetimepicker'

  export default {
    name: 'applyStampUse',
    data() {
      return {
        form: {
          useTime: '', // 用章日期
          category: '', // 印章类别
          fileName: '', // 文件名称
          forUse: '', // 用途说明
          quantity: '', // 份数
          remark: '' // 备注
        }
      }
    },
    components: {datepicker},
    mounted: function () {
    },
    methods: {
      submit: function () { // 发起用章申请
        let self = this
        const company = localStorage.getItem('companyInfo')
        if (!self.form.useTime || !self.form.category || !self.form.fileName || !self.form.forUse || !self.form.quantity) {
          alert('请将申请单填写完毕')
          return
        }

        const formData = {
          '公司ID': JSON.parse(company).id,
          '用章日期': self.form.useTime,
          '印章类别': self.form.category,
          '文件名称': self.form.fileName,
          '用途说明': self.form.forUse,
          '份数': self.form.quantity,
          '备注': self.form.remark,
        }

        console.log('___提交表单 formData', formData)
        self.global.axiosPost(self, 'apply/2/', formData, function (res) {
          console.log('/apply/2/', res)
          if (res.status === 'success') {
            alert('提交成功')
          }
        })
      },

      datePicker: function (elementId) {
        let self = this
        WdatePicker({
          el: elementId,
          dateFmt: 'yyyy-MM-dd HH:mm:ss', //日期格式，可以只显示年或年月，也可以额外显示时间
          onpicked: function () {
            var value = $('#' + elementId).val()
            console.log('___日期elementId', elementId, value)
            self.form[elementId] = value
          },
          oncleared: function () {
            self[elementId] = null
          },
          isShowClear: true,
          readOnly: true
        })
      },
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyStampUse.vue